module.exports = __webpack_public_path__ + "221df3c66dc8819e4750cf642db7a913.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/city-24.png
 ** module id = 1015
 ** module chunks = 0
 **/